import React, { useState } from "react";
import { Camera, AlertTriangle } from "lucide-react";

import { getToken } from "../utils/tokenStorage";
export default function ScreenshotCard({ scanId, available }) {
  const [loaded, setLoaded] = useState(false);
  const [errored, setErrored] = useState(false);

  if (!available || !scanId) return null;

  const token = getToken("aegis_token");
  const imgSrc = `/api/scan/screenshot/${scanId}`;

  return (
    <div className="au-glass au-pad" style={{ marginBottom: 20 }}>
      <div className="au-eyebrow" style={{
        marginBottom: 18,
        paddingBottom: 14, borderBottom: "1px solid var(--au-hair)",
        display: "flex", justifyContent: "space-between", alignItems: "center"
      }}>
        <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
          <Camera size={14} aria-hidden="true" /> VISUAL EVIDENCE — TARGET CAPTURE
        </span>
        {loaded && (
          <span className="au-chip au-chip-status" style={{ color: "var(--au-success)" }}>
            <span className="au-led" /> CAPTURED
          </span>
        )}
      </div>

      <div style={{
        borderRadius: "var(--au-r-sm)", overflow: "hidden",
        border: "1px solid var(--au-hair)",
        background: "var(--au-bg)",
        position: "relative",
        minHeight: errored ? 80 : 200
      }}>
        {errored && (
          <div style={{
            padding: 30, textAlign: "center", color: "var(--au-warn)", fontSize: 13,
            display: "flex", alignItems: "center", justifyContent: "center", gap: 8
          }}>
            <AlertTriangle size={14} aria-hidden="true" /> Screenshot capture failed — target may have blocked automated access
          </div>
        )}
        {!errored && (
          <img
            src={imgSrc}
            alt="Target screenshot"
            onLoad={() => setLoaded(true)}
            onError={() => setErrored(true)}
            style={{
              width: "100%", display: "block",
              opacity: loaded ? 1 : 0.4,
              transition: "opacity 0.3s"
            }}
          />
        )}
      </div>

      {loaded && (
        <div style={{
          fontSize: 10, color: "var(--au-muted)", marginTop: 10, textAlign: "right"
        }}>
          Captured at scan time · 1280×800 viewport
        </div>
      )}
    </div>
  );
}
